/*
 * @Descripttion:
 * @version:
 * @Author: afeng510
 * @Date: 2021-08-11 20:35:52
 * @LastEditors: afeng510
 * @LastEditTime: 2021-08-31 15:58:28
 */

const getDefaultState = () => {
  return {
    userInfo:null,

  }
}

const state = getDefaultState()

const mutations = {
  SET_USER_INFO: (state, userinfo) => {
    state.userInfo = userinfo
  }
}

const actions = {
  setUserInfo({ commit }, userinfo) {
    commit('SET_USER_INFO', userinfo)
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

